<template>
  <div :style="styles.base" :class="getCss('footer-download')" v-show="UnDownloadStatusShow">

    <div :style="{backgroundColor: configurationData.backgroundColor,
    '--backgroundProcessBg':configurationData.processColor,
    height:'100%',padding: '0px 0px 0px 0px'}"
         @click="clickDownLoad">
      <a v-show="UnDownloadStatus" href="javascript:;" class="actModules_actionBtn undownload">
        <p :style="{color: configurationData.mainTitleColor}" class="down-rightnow">{{ mainTitle }}</p>
        <p :style="{color: configurationData.subtitleColor,height: '0.6804rem',padding: '0.1rem 0px 0px 0px'}"
           class="actModules_actionBtnTips">{{ subtitle }}</p>
      </a>
      <a v-show="startGameStatus"
         @click="startGame"
         href="javascript:;" class="actModules_actionBtn installed">
        <p>启动游戏</p>
      </a>
      <a
        v-show="readyInstallGameStatus"
        @click="clickInstallGame"
        href="javascript:;" class="actModules_actionBtn finish">
        <p>腾讯认证正式 点击安装</p>
      </a>
      <a
        v-show="showProcessDownloading"
        href="javascript:;"
        class="actModules_actionBtn download-progress"
      >
        <div :class="getCss('actModules_DownLoadBar')"
             ref="downloadProgressBar"
             :style="progressStyle"
        ></div>
        <div class="download-progress-detail">
          <p>
            <span :class="getCss('download-progress-download')">
             <span>正在下载</span>
            <span :class="getCss('download-progress-text')" v-text="downloadProgress"></span>
                <span>%,点击暂停</span>
            </span>
          </p>
          <a class="cancel-download-button" v-if="isShowCancelDownload" @click="clickCancelDownload">取消下载</a>
        </div>
      </a>
      <a
        v-show="showProcessDownloadPause"
        href="javascript:;"
        class="actModules_actionBtn  download-progress"
      >
        <div :class="getCss('actModules_DownLoadBar')"
             ref="downloadProgressBar"
             :style="progressStyle"
        ></div>
        <div class="download-progress-detail">
          <p>
            <span :class="getCss('download-progress-download')">
             <span>已暂停下载,点击继续</span>
            </span>

          </p>
          <a class="cancel-download-button" v-if="isShowCancelDownload"
             @click="clickCancelDownload">取消下载</a>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
// import jsbridge from '../../libs/jsbridge'
const SPARK_APP_START_DOWNLOAD_CODE = 0;
const SPARK_APP_PAUSE_DOWNLOAD_CODE = 1;
let response = null;// 全部变量存储请求接口
export default {
  name: 'CShanxianFooterDownload',
  components: {},
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'shanxian-footer-download-',
      downloadState: 0,
      downloadProgress: 0,
      UnDownloadStatus: true,
      showProcessDownloadPause: false,
      showProcessDownloading: false,
      downloadSize: 0,
      readyInstallGameStatus: 0,
      startGameStatus: 0,
      thenval: 0,
      widthLists: 0,
      downloadPercent2: 0,
      downloadPercent1: 0,
      UnDownloadStatusShow: true,
      // 取消下载的参数 因为第一个开发同学代码接口混乱
      cancelDownloadParams: {
        url: '',
        packageName: '',
      },
    };
  },
  computed: {
    progressStyle() {
      return {
        width: `${this.downloadPercent2}%`,
        backgroundColor: this.configurationData.processColor,
        // height: '100%',
        // transform: 'translateY(-2%)',
        height: '1.28rem',
        padding: '5px 0px 0px 0px',
      };
    },
    mainTitle() {
      return this.configurationData.mainTitle ? this.configurationData.mainTitle : '立即下载';
    },
    subtitle() {
      return this.configurationData.subtitle ? this.configurationData.subtitle : '新版来袭，体验新派武侠世界';
    },
    isShowCancelDownload() {
      return this.isAppVersionBiggerThan([1, 9, 16, 153]);
    },
  },
  created() {
    const { gid } = this.configurationData;
    if (gid > 0 && this.$ast.isAPP()) {
      this.$axiosInstance.get(`https://wang.xinyue.qq.com/api/fly/getPkgByGid?gid=${gid}`).then((res) => {
        response = res;
      });
    }
  },
  async mounted() {
    if (this.$isInEditor) return;
    // 判断是否在提审
    if (window?.SX_WEB.tool.env.isSwitchOn) {
      this.UnDownloadStatusShow = false;
    }
    console.log('SX_WEB.tool.env.isSwitchOn', window?.SX_WEB.tool.env.isSwitchOn);
    const b = this;
    window?.SX_WEB.jsBridge.app.isAppInstalled({ identifier: this.configurationData.packageName }).then((a) => {
      b.thenval = a;
      if (a && window?.SX_WEB.tool.env.android) {
        this.showProcessDownloadPause = false;
        this.showProcessDownloading = false;
        this.readyInstallGameStatus = false;
        this.UnDownloadStatus = false;
        this.startGameStatus = true;
      }
      // console.log('this.thenval',a);
    });
    const { gid, url: androidDownloadUrl, packageName } = this.configurationData;
    if (gid === 0 && typeof url === 'string' && url.length > 0 && packageName) {
      this.cancelDownloadParams = {
        url: androidDownloadUrl,
        packageName,
      };
    }
    console.log('configurationData=', this.configurationData);
  },
  methods: {
    startGame() {
      window.SX_WEB?.jsBridge.app.launchApp({
        identifier: this.configurationData.packageName,
      }).then((res) => {
        console.log('launchApp res', res);
      });
    },
    clickInstallGame() {
      const { url, appName, packageName, iconUrl }  = this.configurationData;
      window?.SX_WEB.jsBridge.app.downloadApk({
        actionCode: SPARK_APP_START_DOWNLOAD_CODE,
        url,
        appName,
        packageName,
        iconUrl,
        callback: async (params) => {
          console.log('1clickInstallGame params', params);
          window?.SX_WEB.jsBridge.app.downloadApk({
            actionCode: SPARK_APP_PAUSE_DOWNLOAD_CODE,
            url,
            appName,
            packageName,
            iconUrl,
            callback: async (params) => {
              console.log('2clickInstallGame params', params);
            },
          });
        },
      });
    },
    getAppVersion() {
      const str = window.navigator.userAgent;
      if (!str) {
        return '';
      }
      if (str.match('com.tencent.gamecommunity') === null) {
        return '';
      }
      let reg = [];
      if (window.SX_WEB.tool.env.ios) {
        reg = new RegExp('com.tencent.gamecommunity/([0-9.]+)');
      } else {
        reg = new RegExp('VERSION_NAME/([0-9.]+)');
      }
      const res = str.match(reg);
      if (!res?.[1]) {
        return '';
      }
      if (!res[1] instanceof Array || res[1].length === 0) {
        return '';
      }
      return res[1];
    },
    isAppVersionBiggerThan(versions) {
      const currentVersion = this.getAppVersion();
      if (!currentVersion) {
        return false;
      }
      const [v1 = 0, v2 = 0, v3 = 0, v4 = 0] = currentVersion.split('.').map(num => parseInt(num, 10));
      console.log('currentVersion spark app v1 v2 v3 v4', v1, v2, v3, v4);
      const [c1 = 0, c2 = 0, c3 = 0, c4 = 0] = versions;
      console.log('passThrough spark app c1 c2 c3 c4', c1, c2, c3, c4);
      if (v1 - c1 < 0) {
        return false;
      }
      if (v1 - c1 > 0) {
        return true;
      }
      if (v2 - c2 < 0) {
        return false;
      }
      if (v2 - c2 > 0) {
        return true;
      }
      if (v3 - c3 < 0) {
        return false;
      }
      if (v3 - c3 > 0) {
        return true;
      }
      if (v4 - c4 < 0) {
        return false;
      }
      if (v4 - c4 > 0) {
        return true;
      }
      if (v1 === c1 && v2 === c2 && v3 === c3 && v4 === c4) {
        return false;
      }
      return false;
    },
    async clickCancelDownload(event) {
      event.stopPropagation();
      const that = this;
      this.$confirm({
        title: '取消下载?',
        msg: '取消后将删除已下载的安装包',
        confirmText: '继续下载',
        cancelText: '取消下载',
        confirm() {
          console.log(' confirm 继续下载');
          if  (that.downloadStatus2 === 'pause') {
            that.clickDownLoad();
          }
        },
        async cancel() {
          console.log('cancel 取消下载');
          console.log('that.cancelDownloadParams', that.cancelDownloadParams);
          window.SX_WEB?.jsBridge.app.cancelDownloadApk(that.cancelDownloadParams);
          that.UnDownloadStatus = true;
          that.showProcessDownloadPause = false;
          that.showProcessDownloading = false;
          that.downloadProgress = 0;
          that.downloadPercent2 = 0;
          that.downloadPercent1 = 0;
          that.downloadStatus2 = '';
          console.log('done cancel 取消下载');
        },
      });
    },
    async clickDownLoad() {
      console.log('clickDownLoad=');
      if (!this.$ast.isAPP()) {
        this.$ast.gotoAPP();
        return;
      }
      const { gid = 0 } = this.configurationData;
      if (gid > 0) {
        console.log('getPkgByGid gid = ', gid);
        console.log('getPkgByGid response = ', response);
        if (response && parseInt(response.ret, 10) === 0 && response.info.androidDownloadUrl) {
          const data = response.info || {};
          if (!data.androidPkgName) {
            console.error('download androidPkgName params empty ', response);
            return;
          }
          data.icon = typeof data.icon === 'string' && data.icon ? JSON.parse(data.icon) : data.icon;
          this.configurationData.iconUrl = !!data.icon[108] === true ? data.icon[108] : data.icon[16];
          this.configurationData.packagename = data.androidPkgName;
          this.configurationData.iosurl = data.IOSDownloadUrl;
          this.configurationData.url = data.androidDownloadUrl;
          this.configurationData.appName = data.gameName;
          this.cancelDownloadParams = {
            url: data.androidDownloadUrl,
            packageName: data.androidPkgName,
          };
          if (window?.SX_WEB.tool.env.ios) {
            this.configurationData.packageName = data.iosPkgName || data.androidPkgName;
          }
          // this.configurationData.iOSPkgName = data.iosPkgName || data.androidPkgName;
        }
      }
      if (this.downloadPercent1 == 0) {
        this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '83');
      }
      if (window?.SX_WEB.tool.env.ios) {
        this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '85');
        if (this.configurationData.flowId > 0) {
          const res = await this.flowRequest({
            flowId: this.configurationData.flowId,
            params: {
              // role: this.roleInfo,
              // data: JSON.stringify({}),
            },
          });
          console.log('launchApp Ios res', res);
          if (res.ret === 0 && res.data.ret === 0) {
            this.refreshQua();
          }
        }
      }
      if (window?.SX_WEB.tool.env.ios) {
        window?.SX_WEB.jsBridge.ui.openUrl({
          url: this.configurationData.iosurl,
          target: 2,
        });
        return;
        // return window.location.href = this.configurationData.iosurl;
      }

      if (this.thenval) {
        if (window?.SX_WEB.tool.env.ios) {
          window?.SX_WEB.jsBridge.app.launchApp({
            downloadUrl: this.configurationData.iosurl,
            scheme: this.configurationData.packageName,
          }).then((res) => {
            console.log('launchApp res', res);
          });
        } else {
          window?.SX_WEB.jsBridge.app.launchApp({
            identifier: this.configurationData.packageName,
          }).then((res) => {
            console.log('launchApp res', res);
          });
        }
        return;
      }
      let actionCode = SPARK_APP_START_DOWNLOAD_CODE;
      let b = 0;
      if (this.downloadStatus2 === 'progress') {
        actionCode = SPARK_APP_PAUSE_DOWNLOAD_CODE;
      } else {
        this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '84');
      }
      console.log('actionCode', actionCode);
      // console.log('download this.downloadStatus2', this.downloadStatus2);
      window?.SX_WEB.jsBridge.app.downloadApk({
        actionCode,
        url: this.configurationData.url,
        appName: this.configurationData.appName,
        packageName: this.configurationData.packageName,
        iconUrl: this.configurationData.iconUrl,
        callback: async (params) => {
          console.log('download APK callback', params);
          this.downloadStatus2 = params.type;
          this.UnDownloadStatus = false;
          this.downloadPercent1 = 1;
          if (params.progress >= 99) {
            this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '06', '36');
            if (this.configurationData.flowId != '') {
              const res = await this.flowRequest({
                flowId: this.configurationData.flowId,
                params: {
                  // role: this.roleInfo,
                  // data: JSON.stringify({}),
                },
              });
              if (res.ret === 0 && res.data.ret === 0) {
                this.refreshQua();
              }
              console.log('download APK res', res);
            }
          }
          if (params.type === 'progress') {
            this.showProcessDownloading = true;
            this.showProcessDownloadPause = false;
            this.readyInstallGameStatus = false;
            this.startGameStatus = false;
            this.downloadProgress = params.progress;
            this.downloadPercent2 = params.progress;
            if (b == 0) {
              this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '86');
              b++;
            }
          } else if (params.type === 'pause') {
            // 暂停
            this.showProcessDownloadPause = true;
            this.showProcessDownloading = false;
            this.readyInstallGameStatus = false;
            this.startGameStatus = false;
          } else if (params.type === 'install') {
            this.showProcessDownloadPause = false;
            this.showProcessDownloading = false;
            this.readyInstallGameStatus = true;
            this.startGameStatus = false;
            this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '06', '36');
            // 触发安装,调下载完成流程
            if (this.configurationData.flowId != '') {
              const res = await this.flowRequest({
                flowId: this.configurationData.flowId,
                params: {},
              });
              if (res.ret === 0 && res.data.ret === 0) {
                this.refreshQua();
              }
              console.log('download APK res install', res);
            }
          } else if (params.type === 'finish') {
            this.showProcessDownloadPause = false;
            this.showProcessDownloading = false;
            this.readyInstallGameStatus = false;
            this.startGameStatus = true;
            this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '06', '36');
            // 下载完成,调下载完成流程
            if (this.configurationData.flowId != '') {
              const res = await this.flowRequest({
                flowId: this.configurationData.flowId,
                params: {},
              });
              if (res.ret === 0 && res.data.ret === 0) {
                this.refreshQua();
              }
              console.log('download APK res finish', res);
            }
          }
        },
      });
    },

  },
};

</script>
<style lang="scss">
@import './styles.scss';


.down-rightnow {
  text-align: center;
  height: 0.5rem;
  font-size: 0.4rem;
  // margin-top: 0.2rem;
  margin-bottom: 0.1rem;
  // color: #000;
}

.installed p,
.finish p {
  height: 1.28rem;
  text-align: center;
  line-height: 1.28rem;
  font-size: 0.4rem;
}

.download-progress-detail {
  z-index: 200;
  width: 7.5rem;
  height: 1.28rem;
  text-align: center;
  line-height: 1.28rem;
  font-size: 0.4rem;
  position: absolute;
  left: 0;
  top: 0;
}

.cancel-download-button {
  position: relative;
  bottom: 0.65rem;
  font-size: 0.32rem;
  right: -2.8rem;
  text-decoration: underline;
}

.download-progress-detail p {
  height: 0.52rem;
  line-height: 0.52rem;
  text-align: center;
  margin-top: 0.38rem;
}

.actModules_actionBtn {
  height: 1.28rem;
  width: 7.5rem;
  color: #4a4a4a;
  font-size: 0.4rem;
  box-align: center;
  box-orient: vertical;
  left: 0;
  bottom: 0;
  margin: 0 auto;
}

.actModules_actionBtnTips {
  font-size: 0.26rem;
  // color: #4a4a4a;
  line-height: 1.2;
  text-align: center;
}

.csu-shanxian-footer-download-actModules_DownLoadBar {
  position: relative;
  height: 2.08rem;
  left: 0;
  top: 0;
  width: 0;
  background: var(--backgroundProcessBg);
  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
}
</style>
